import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { FullWidthGridColumn, GridRow } from 'components/StaticGrid'
import { useTranslation } from 'react-i18next'
import { StyledTextField } from './Steps.styles'
import {
  Container,
  FullWidthButton,
  FormWrapper
} from '../../components/AuthForm.styles'
import { Tonality } from '@dsny/dsny-component-library'
import { useTheme } from 'styled-components'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { stepTwoSchema } from './schema'
import { thunks as AuthThunks } from 'reducers/Auth'

export default function StepTwo({ signUpData, onSubmit }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const dispatch = useDispatch()
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(stepTwoSchema)
  })

  useEffect(() => {
    dispatch(AuthThunks.sendEmailVerificationCode(signUpData?.email))
  }, [])

  return (
    <Container style={{ padding: 0, alignItems: 'flex-start' }}>
      <Tonality.UIHeading
        headingStyle="headline4"
        color={theme.colors.neutralW100}
        style={{ marginBottom: 32 }}
      >
        {t('signup.verify-your-email')}
      </Tonality.UIHeading>
      <Tonality.UIText
        textStyle="body"
        color={theme.colors.neutralW70}
        style={{ marginBottom: 24 }}
      >
        {t('signup.verify-your-email-body-one')} [{signUpData?.email}]
      </Tonality.UIText>

      <Tonality.UIText textStyle="body" color={theme.colors.neutralW70}>
        {t('signup.verify-your-email-body-two')}
      </Tonality.UIText>

      <FormWrapper style={{ marginTop: 32 }}>
        <form
          data-cy="signup-step-two-form"
          onSubmit={handleSubmit((values, e) => onSubmit(values, e))}
        >
          <GridRow style={{ marginBottom: 16 }}>
            <FullWidthGridColumn>
              <div data-cy="signup-verification-code">
                <StyledTextField
                  id="verificationCode"
                  name="verificationCode"
                  required
                  {...register('verificationCode')}
                  ref={null}
                  inputRef={register('verificationCode').ref}
                  labelText={t('signup.verification-code')}
                  error={errors.verificationCode?.message}
                  maxLength={5}
                />
              </div>
            </FullWidthGridColumn>
          </GridRow>

          <GridRow style={{ marginBottom: 32, marginLeft: 0 }}>
            <Tonality.UIText
              textStyle="body"
              color={theme.colors.neutralW100}
              style={{ marginRight: 8 }}
            >
              {t('signup.didnt-receive-code')}
            </Tonality.UIText>

            <Tonality.UIText
              textStyle="body"
              color={theme.colors.player50}
              style={{ cursor: 'pointer' }}
            >
              {t('login.resend-email')}
            </Tonality.UIText>
          </GridRow>
          <FullWidthButton
            data-cy="signup-step-two-submit"
            type="submit"
            color="primary"
            setting="player"
          >
            {t('signup.proceed-to-next-step')}
          </FullWidthButton>
        </form>
      </FormWrapper>
    </Container>
  )
}
